import React, { createContext } from "react";

export type DrawerContextValue = {
  state: { isOpen: boolean };
  dispatch: any;
};

export const DrawerContext = createContext<DrawerContextValue>({
  state: { isOpen: false },
  dispatch: () => {},
});
